import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import Tooltip from "@material-ui/core/Tooltip";
import SearchIcon from "@material-ui/icons/Search";
import Drawer from "@material-ui/core/Drawer";
import DrawerHeader from "Component/Headers/drawerHeader";
import classNames from "classnames";
import get from "lodash/get";
import { withSnackbar } from "notistack";
// import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import { RightDrawer } from "../../../Actions/commonAction";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import { updateSubscriptionInfo } from "../../../Actions/SubscriptionInfo";
import defaultEmp from "../../../Assets/Images/defaultEmp.svg";
// import "../../../Assets/Css/ReportRobo.scss";
import "../../../Assets/SCSS/components/ReportRobo.scss";
import previewIcon from "Assets/newicons/user-interface/eye-show/outline/eye-show-outline-16px.svg";

import createstore from "../../../store";
import {
  getFormattedDate,
  getFormattedImageLink,
  getFormattedTimeFromDate,
} from "../../../Utils";
import CustomLoader from "Component/CustomLoader";


const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  searchIcon: {
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    // pointerEvents: "none",
    display: "flex",
    alignItems: "left",
    justifyContent: "left",
    paddingLeft: 10,
    paddingTop: 10,
  },
});

class ReportHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 50,
      offset: 0,
      fullcount: 0,
      page: 0,
      reportList: [],
      search: "",
      message: "",
    };
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
   // this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    // window.addEventListener("scroll", this.handleScroll);
    // window.scrollTo(0, 0);
    // window.addEventListener("beforeunload", this.onBeforeUpload);
  }

  componentWillMount() {
    const { SubscriptionInfo } = createstore.getState();
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];
    this.setState({ ShortDateFormat });
    this.getReports();
  }

  // componentWillUnmount() {
  //   window.removeEventListener("beforeunload", this.onBeforeUpload);
  //   window.removeEventListener("scroll", this.handleScroll);
  // }

  // handleScroll() {
  //   const windowHeight =
  //     "innerHeight" in window
  //       ? window.innerHeight
  //       : document.documentElement.offsetHeight;
  //   const { body } = document;
  //   const html = document.documentElement;
  //   const docHeight = Math.max(
  //     body.scrollHeight,
  //     body.offsetHeight,
  //     html.clientHeight,
  //     html.scrollHeight,
  //     html.offsetHeight,
  //   );
  //   const windowBottom = windowHeight + window.pageYOffset;
  //   if (
  //     windowBottom >= docHeight &&
  //     this.state.reportList.length < this.state.fullcount
  //   ) {
  //     this.setState(
  //       {
  //         offset: this.state.offset + 10,
  //       },
  //       () => this.getReports(),
  //     );
  //   } else {
  //     this.setState({
  //       message: "no data",
  //     });
  //   }
  // }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  getReports() {
    this.setState({isloading:true}, () => {
      instance
      .get(`reportrobo/historyreport/${this.state.offset}/${this.state.limit}`)
      .then(
        (result) => {
          let reportList = [];
          const fullcount = result.data.result[0]
            ? result.data.result[0].fullcount
            : 0;
          result.data.result.length > 0
            ? (reportList = [...this.state.reportList, ...result.data.result])
            : (reportList = this.state.reportList);

          this.setState({ fullcount, reportList, isloading:false });
        },
        (error) => {
          this.setState({isloading:false})
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        },
        );
    })
   
     
  }

  handleChangePage = (event, page) => {
    this.setState({ page, offset: this.state.limit * page }, () => {
      this.getReports();
    });
  };

  handleChangeRowsPerPage = (event, page) => {
    this.setState(
      {
        limit: event.target.value,
        offset: event.target.value * this.state.page,
      },
      () => {
        this.getReports();
      },
    );
  };

  HelperSliderFlag(flag, report) {
    let OpenFlag = "";
    if (flag == true) {
      OpenFlag = true;
      this.setState({ OpenFlag });
    } else {
      OpenFlag = false;
      this.setState({ OpenFlag });
    }
    this.props.RightDrawer({
      drawerdata: "HistoryUserReport",
      open: "right",
      side: flag,
      histrptid: report.reportrobologid,
    });
  }

  getCountManager = (count) => {
    if (count >= 3) {
      return count - 3;
    }
    return 0;
  };

  viewReportDetails(report) {
    this.setState({ selectedReport: report, isView: true });
  }

  searchOnChange(event) {
    this.setState({ search: event.target.value });
  }

  render() {
    const filteredReport = this.state.reportList.filter((agent) => {
      if (!agent.reportname) {
        return false;
      }
      return (
        agent.reportname
          .toLowerCase()
          .indexOf(this.state.search.toLowerCase()) != -1
      );
    });

    const { classes } = this.props;
    const { selectedReport } = this.state;
    const language = this.props.Language.reportrobo;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className={classes.root}>
          <Grid container style={{ marginBottom: 20 }}>
            <Grid item xs={12} md={9} sm={6}>
              <div className="inner-wrapper opaque">
                <div className="form-group">
                  <p className="center">
                    <FormattedMessage id="LbShowing" defaultMessage="Showing" />{" "}
                    {filteredReport.length} of {filteredReport.length}
                  </p>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={3} sm={6} className="right">
              <div style={{ marginRight: 20 }}>
                <FormControl
                  className={`${classes.searchIcon} searchBox`}
                  style={{
                    height: 38,
                    width: 230,
                    paddingTop: 0,
                    borderRadius: 5,
                    border: "1px solid #d8d8d8",
                  }}
                >
                  <Input
                    placeholder="Search"
                    style={{ height: 35 }}
                    disableUnderline
                    value={this.state.search}
                    fullWidth
                    onChange={this.searchOnChange.bind(this)}
                    startAdornment={
                      <InputAdornment position="start">
                        <SearchIcon color="disabled" />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </div>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12} md={12} sm={12} className="">
              <Table className="table-reportrobo">
                <thead>
                  <tr>
                    <th style={{ width: "35%" }}>
                      <FormattedMessage
                        id="LbReportName"
                        defaultMessage="Report Name"
                      />
                    </th>
                    <th style={{ width: "25%" }}>
                      <FormattedMessage
                        id="LbRecipients"
                        defaultMessage="Recipients"
                      />
                    </th>
                    <th style={{ width: "20%" }}>
                      <FormattedMessage
                        id="LbSentOn"
                        defaultMessage="Sent On"
                      />
                    </th>
                    <th style={{ width: "20%" }}>
                      <span>View</span>
                    </th>
                  </tr>
                </thead>
                {this.state.isloading ? 
                  <tbody>
                  <tr>
                   <td colSpan="5" className="noData no-data">
                   <CustomLoader />
                   </td>
                 </tr>
                 </tbody>
              
              :  <tbody>
                  {filteredReport.length > 0 ? (
                    filteredReport.map((report, index) => (
                      <tr>
                        <td>
                          <span>{report.reportname}</span>
                          {/* <p>{moment(report.updateddate).format('DD-MMM-YYYY')}</p> */}
                        </td>
                        <td>
                          <div style={{ display: "inline-flex" }}>
                            {report.assignedEmployeeList.length > 0 ? (
                              report.assignedEmployeeList.map((mgr) => (
                                <Tooltip
                                  title={mgr.employeename}
                                  placement="bottom"
                                >
                                  <Link
                                    to={`./profile/${mgr.employeeid}`}
                                    target="_blank"
                                  >
                                    <div className="inlineClass">
                                      {mgr.imagepath == null ? (
                                        <img
                                          src={defaultEmp}
                                          height="56"
                                          className="team-img1"
                                          style={{ marginTop: -10 }}
                                        />
                                      ) : (
                                        <img
                                          src={getFormattedImageLink(
                                            mgr.imagepath,
                                          )}
                                          height="56"
                                          className="team-img1"
                                          style={{ marginTop: -10 }}
                                        />
                                      )}
                                    </div>
                                  </Link>
                                </Tooltip>
                              ))
                            ) : (
                              <div className={classNames("manager")}>
                                <FormattedMessage
                                  id="LbNoRecipientsAdded"
                                  defaultMessage="No Recipients Added"
                                />
                              </div>
                            )}
                            {report.assignedEmployeeList.length > 0 ? (
                              this.getCountManager(
                                report.assignedEmployeeList[0].fullcount,
                              ) > 0 ? (
                                <div
                                  className={classNames(
                                    "managerdrawer",
                                    "cursour-pointer",
                                  )}
                                  onClick={this.HelperSliderFlag.bind(
                                    this,
                                    true,
                                    report,
                                  )}
                                >
                                  +
                                  {this.getCountManager(
                                    report.assignedEmployeeList[0].fullcount,
                                  )}
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </div>
                        </td>
                        <td>
                          {getFormattedDate(
                            report.sentdate,
                            this.state.ShortDateFormat,
                          )}
                          <div>{getFormattedTimeFromDate(report.sentdate)}</div>
                        </td>
                        <td className="position-rel">
                            <img
                              src={previewIcon}
                              onClick={() => this.viewReportDetails(report)}
                              className="cursor-pointer"
                            ></img>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="noData no-data">
                        No Record Found
                      </td>
                    </tr>
                  )}
                </tbody>
}
              </Table>
            </Grid>
          </Grid>
          <Drawer
            anchor="right"
            open={this.state.isView}
            onClose={() => this.setState({ isView: false })}
            style={{ padding: 40 }}
            classes={{
              paper: "planner-drawer padding15 width25",
            }}
          >
            <DrawerHeader
              header="Details"
              isbackarrow={false}
              closeDrawer={() =>
                this.setState({
                  isView: false,
                })
              }
            />
            <div>
              <p className="extra-small-dark-secondary">Report Name</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.reportname}
              </p>

              <p className="extra-small-dark-secondary">Genration Type</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport
                  ? selectedReport.generationtypeid
                    ? selectedReport.generationtypeid == 1 
                      ? "Onetime" 
                      : "Schedule"
                    : "Not Available"
                  : "-"}
              </p>
              {selectedReport && selectedReport.frequencytype && (
                <>
                <p className="extra-small-dark-secondary">Frequency Type</p>
                <p className="small-dark margin-bottom-8">
                    {selectedReport.frequencytype}
                </p>
                </>
              )}
              <p className="extra-small-dark-secondary">Report Period</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.reportperiod
                  ? selectedReport.reportperiod
                  : "-"}
              </p>
              <p className="extra-small-dark-secondary">Generated By</p>
              <p className="small-dark margin-bottom-8">
                {selectedReport && selectedReport.generatedby
                  ? selectedReport.generatedby
                  : "-"}
              </p>
            </div>
          </Drawer>
        </div>
      </IntlProvider>
    );
  }
}

ReportHistory.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateSubscriptionInfo: (type, payload) =>
        updateSubscriptionInfo(type, payload),
      RightDrawer: (data) => RightDrawer(data),
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ReportHistory)));
